import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index.vue'
// import Order from '../views/Order.vue'
// import Particulars from '../views/Particulars.vue'
// import Search from '../views/Search.vue'

Vue.use(VueRouter)

const routes = [{
		path: '/',
		name: 'index',
		component:index,
	},
]

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes
})

export default router
